$(document).on('click', '.modal-open-btn', function(){
  $('#overlay').fadeIn();
});
$(document).on('click', '#modal-close-btn', function(){
  $('#overlay').fadeOut();
});
